// File: /src/components/DocumentForm.js

import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { FaUpload } from 'react-icons/fa';

function DocumentForm({ handleSubmit }) {
	const [selectedFile, setSelectedFile] = useState(null);
	const [dragActive, setDragActive] = useState(false);

	const handleDrag = (e) => {
		e.preventDefault();
		e.stopPropagation();
		if (e.type === 'dragenter' || e.type === 'dragover') {
			setDragActive(true);
		} else if (e.type === 'dragleave') {
			setDragActive(false);
		}
	};

	const handleDrop = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setDragActive(false);
		if (e.dataTransfer.files && e.dataTransfer.files[0]) {
			setSelectedFile(e.dataTransfer.files[0]);
		}
	};

	const handleFileSelect = (e) => {
		if (e.target.files && e.target.files[0]) {
			setSelectedFile(e.target.files[0]);
		}
	};

	const onSubmit = (e) => {
		e.preventDefault();
		if (selectedFile) {
			handleSubmit(selectedFile);
			setSelectedFile(null);
		}
	};

	return (
		<Box sx={{ p: 2 }}>
			<form onSubmit={onSubmit}>
				<Box
					sx={{
						border: '2px dashed #ccc',
						borderRadius: 2,
						p: 3,
						textAlign: 'center',
						bgcolor: dragActive ? '#f0f0f0' : 'transparent',
						cursor: 'pointer',
						'&:hover': {
							bgcolor: '#f0f0f0',
						},
					}}
					onDragEnter={handleDrag}
					onDragLeave={handleDrag}
					onDragOver={handleDrag}
					onDrop={handleDrop}
					onClick={() =>
						document.getElementById('file-input').click()
					}
				>
					<input
						type="file"
						id="file-input"
						style={{ display: 'none' }}
						onChange={handleFileSelect}
					/>
					<FaUpload
						style={{
							fontSize: '2rem',
							color: '#666',
							marginBottom: '1rem',
						}}
					/>
					<Typography>
    {selectedFile
        ? `Arquivo selecionado: ${selectedFile.name}`
        : (
            <>
                Arraste um arquivo ou clique para selecionar<br />
                Tamanho máximo: 5mb <br />
				Permitido PNG, JPG, PDF, DOCX, XLSX, PPTX
            </>
        )
    }
</Typography>
				</Box>
				<Button
					type="submit"
					variant="contained"
					fullWidth
					sx={{ mt: 5 }}
					disabled={!selectedFile}
				>
					SALVAR
				</Button>
			</form>
		</Box>
	);
}

export default DocumentForm;
